import React from 'react'
import './destin.css'
import moonimg from './image-mars.png'
const Destin = () => {
  return (
    <div className='destination'>
        <h1 className='pick'><span>01</span>PICK YOUR DESTINATION</h1>
<div className='maindestin'>
  <div className='imgmoon'>
 <img className='moonimg' src={moonimg} alt='moon'/>
  </div>
  <div className='right'>
    <ul className='uls'>
        <li className='listss'>MOON</li>
        <li className='listss'>MARS</li>
        <li className='listss'>EUROPE</li>
        <li className='listss'>TITAN</li>
        
    </ul>
    <h1 className='mars'>MARS</h1>
    <p className='paras'>Dont forget to packYour hiking boots, You'll need them to tackle Olympus Mons, the tallest planetary mountain in solar system. its two and a half times of the sizes of the everst</p>
    <div className='meter'>
        <div className='moonmeter'>
       <h4>Avg. Distance</h4>
       <h3>225 MIL.KM</h3>
        </div>
        <div className='moonmeter'>
        <h4>EST. TRAVEL TIME</h4>
       <h3>9 MONTHS</h3>
            </div>
    </div>
  </div>
</div>
    </div>
  )
}

export default Destin